/** @jsxImportSource ./i18n */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter/opsz.css';
import '@fontsource-variable/fraunces/opsz.css';
import './index.css';
import App from './App';
import { store } from './store';
import { listenForInstallPrompt } from './services/installPrompt';
import { registerServiceWorker } from './services/push';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// The service worker only shows push notifications (no offline cache).
listenForInstallPrompt();
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => { registerServiceWorker().catch(() => {}); });
}
